/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const BiteUAPI = {
  getCourses: async() =>
    (await initAxios())?.get('/bite-u/')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  searchCourses: async(query: any) =>
    (await initAxios())?.post('/bite-u/search', JSON.stringify(query),)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getCourse: async(Course_id: string) =>
    (await initAxios())?.get(`/bite-u/${Course_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateCourse: async(CourseBody: any) =>
    (await initAxios())?.put('/bite-u', JSON.stringify(CourseBody),)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  createCourse: async(CourseBody: any) =>
    (await initAxios())?.post('/bite-u', JSON.stringify(CourseBody),)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  deleteCourse: async(Course_id: string) =>
    (await initAxios())?.delete(`/bite-u/${Course_id}`,)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),


  createUserTrainingStatus: async(body: any) =>
    (await initAxios())?.post('/bite-u/training-status', JSON.stringify(body),)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getUserTrainingStatus: async() =>
    (await initAxios())?.get('/bite-u/training-status')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateUserTrainingStatus: async(body: any) =>
    (await initAxios())?.put('/bite-u/training-status', JSON.stringify(body),)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateUserProgress: async(body: any, progress_id: string) =>
    (await initAxios())?.put(`/bite-u/training-status/${progress_id}`, JSON.stringify(body),)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  deleteUserTrainingStatus: async(status_id: string) =>
    (await initAxios())?.delete(`/bite-u/${status_id}`,)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default BiteUAPI;
